import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from '../../redux/themeprovider';
import { useTheme as useUITheme } from '../ui/theme-provider';
import { setTheme } from '../../redux/theme-slice';
// Helper function to check if a theme is 'system'
const isSystemTheme = (theme) => {
    return theme === 'system';
};
// Helper function to get the system theme preference
const getSystemTheme = () => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark';
    }
    return 'light';
};
/**
 * Component that ensures themes are properly initialized and applied
 * This component only runs once during application startup
 */
function ThemeInitializer() {
    const { theme } = useTheme();
    const { setTheme: setUITheme, theme: uiTheme } = useUITheme();
    const dispatch = useDispatch();
    useEffect(() => {
        // This is a one-time initialization that runs only at mount
        const initializeThemes = () => {
            // Get the HTML root element
            const root = document.documentElement;
            // Remove any potential leftover theme classes
            root.classList.remove('light', 'dark', 'mellowYellow', 'purpleRain', 'blueSky', 'custom-theme', 'theme-mellowYellow', 'theme-purpleRain', 'theme-blueSky');
            // Add theme-transition class for smooth transitions
            if (!root.classList.contains('theme-transition')) {
                root.classList.add('theme-transition');
            }
            // Set the data-theme attribute for CSS variables
            if (isSystemTheme(uiTheme)) {
                // For system, we need to check the system preference
                const systemTheme = getSystemTheme();
                root.setAttribute('data-theme', systemTheme);
                root.classList.add(systemTheme);
                // Ensure Redux knows we're using system theme
                dispatch(setTheme('system'));
                // Set up system theme change listener
                const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
                const handleSystemThemeChange = (e) => {
                    const newSystemTheme = e.matches ? 'dark' : 'light';
                    root.classList.remove('light', 'dark');
                    root.classList.add(newSystemTheme);
                    root.setAttribute('data-theme', newSystemTheme);
                };
                // Add listener for system theme changes
                mediaQuery.addEventListener('change', handleSystemThemeChange);
            }
            else {
                // For explicit theme choice
                root.setAttribute('data-theme', theme.name);
                root.classList.add(theme.name);
                // For custom themes, add a class for special styling
                if (['mellowYellow', 'purpleRain', 'blueSky'].includes(theme.name)) {
                    root.classList.add('custom-theme');
                }
            }
        };
        // Run initialization immediately
        initializeThemes();
        // Log initialization
    }, []); // Empty dependency array - this runs once on mount
    return null;
}
;
export default ThemeInitializer;
